import { gql } from '@apollo/client'
import { useCustomMutation } from 'utils/mutations'

// SELDON_BEATTIE_UPDATE

const mutation = gql`
  mutation wellnessSeldonBeattieFormUpdate(
    $id: ID!
    $attributes: SeldonBeattieFormInput
    $include_patient_name: Boolean = false
    $include_screen_date: Boolean = false
    $include_height: Boolean = false
    $include_weight: Boolean = false
    $include_body_mass_index: Boolean = false
    $include_a1c: Boolean = false
    $include_blood_pressure: Boolean = false
    $include_total_cholesterol: Boolean = false
    $include_ldl_cholesterol: Boolean = false
    $include_hdl_cholesterol: Boolean = false
    $include_triglycerides: Boolean = false
    $include_fasting_glucose: Boolean = false
    $include_smoking_attestation: Boolean = false
  ) {
    wellnessSeldonBeattieFormUpdate(id: $id, seldon_beattie_form: $attributes) {
      id
      employee_id
      patient_name @include(if: $include_patient_name)
      screen_date @include(if: $include_screen_date)
      height @include(if: $include_height)
      weight @include(if: $include_weight)
      body_mass_index @include(if: $include_body_mass_index)
      a1c @include(if: $include_a1c)
      blood_pressure @include(if: $include_blood_pressure)
      total_cholesterol @include(if: $include_total_cholesterol)
      ldl_cholesterol @include(if: $include_ldl_cholesterol)
      hdl_cholesterol @include(if: $include_hdl_cholesterol)
      triglycerides @include(if: $include_triglycerides)
      fasting_glucose @include(if: $include_fasting_glucose)
      smoking_attestation @include(if: $include_smoking_attestation)
      updated_at
    }
  }
`
export default function useWellnessFormUpdate() {
  const { onMutate: onWellnessFormUpdate, loading } = useCustomMutation({
    mutation,
    responsePath: 'wellnessSeldonBeattieFormUpdate',
    successMessage: 'Wellness form updated'
  })

  return { onWellnessFormUpdate, loading }
}
